import { render, staticRenderFns } from "./ConfirmDeleteBusinessModal.vue?vue&type=template&id=2dae06ae&"
import script from "./ConfirmDeleteBusinessModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeleteBusinessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports